/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { ProductListAssignmentOperation } from './ProductListAssignmentOperation';
// @ts-ignore
import {
// @ts-ignore
    ProductListAssignmentOperationFromJSON,
// @ts-ignore
    ProductListAssignmentOperationFromJSONTyped,
// @ts-ignore
    ProductListAssignmentOperationToJSON,
} from './ProductListAssignmentOperation';

/**
 * 
 * @export
 * @interface AssignOrUnassignStoresToProductList
 */
export interface AssignOrUnassignStoresToProductList {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignOrUnassignStoresToProductList
     */
    storeIds: Array<string>;
    /**
     * 
     * @type {ProductListAssignmentOperation}
     * @memberof AssignOrUnassignStoresToProductList
     */
    operation: ProductListAssignmentOperation;
}

/**
 * Check if a given object implements the AssignOrUnassignStoresToProductList interface.
 */
// @ts-ignore
export function instanceOfAssignOrUnassignStoresToProductList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "storeIds" in value;
    isInstance = isInstance && "operation" in value;

    return isInstance;
}

// @ts-ignore
export function AssignOrUnassignStoresToProductListFromJSON(json: any): AssignOrUnassignStoresToProductList {
    return AssignOrUnassignStoresToProductListFromJSONTyped(json, false);
}

// @ts-ignore
export function AssignOrUnassignStoresToProductListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignOrUnassignStoresToProductList {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'storeIds': json['store_ids'],
        'operation': ProductListAssignmentOperationFromJSON(json['operation']),
    };
}

// @ts-ignore
export function AssignOrUnassignStoresToProductListToJSON(value?: AssignOrUnassignStoresToProductList | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'store_ids': value.storeIds,
        'operation': ProductListAssignmentOperationToJSON(value.operation),
    };
}

